// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"mainLayout_mainLayout__1oGsX","mainArea":"mainLayout_mainArea__2J2LW"};